import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { setStatusSchema } from '../../../../shared/validators/schemas/set-status.schema';
import { LocationRecordDto } from '../../dtos/location-record.dto';
import { LocationActionEnum } from '../../enums/location-action.enum';
import { LocationStatusEnum } from '../../enums/location-status.enum';

/**
 * Validates if an action can be performed by validating the record data.
 * @param record - The record for the data validation.
 * @param action - The action to be validated.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canPerformAction = (
  record: LocationRecordDto,
  action: LocationActionEnum,
  abortEarly = false,
): ValidationFunctionResult => {
  // Check if record is provided
  if (!record) throw new Error('record is required.');

  let validationResult: ValidationResult | undefined;

  const fixedStatuses = [LocationStatusEnum.OPEN, LocationStatusEnum.CLOSED];

  switch (action) {
    case LocationActionEnum.OPEN:
      validationResult = setStatusSchema(
        LocationStatusEnum.OPEN,
        fixedStatuses,
      ).validate(record, {
        abortEarly,
      });
      break;

    case LocationActionEnum.CLOSE:
      validationResult = setStatusSchema(
        LocationStatusEnum.CLOSED,
        fixedStatuses,
      ).validate(record, {
        abortEarly,
      });
      break;

    case LocationActionEnum.ASSIGN_VEHICLE:
      break;

    default:
      throw new Error(`Unknown action: ${action}`);
  }

  // Check for validation errors
  if (validationResult?.error) {
    return {
      isValid: false,
      errors: validationResult.error.details?.map((e) => e.message),
    };
  }

  // Return valid result if no errors
  return { isValid: true };
};
